import { BaseRouteService } from 'core/services';

class HolidayRouteService extends BaseRouteService {
    constructor() {
        super('holidays');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,fromDate,toDate}', filter);
    }
}

export default HolidayRouteService;
